import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Checkbox, Menu, MenuItem } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const styles = {
  button: {
    fontWeight: 'bold',
    fontSize: 12,
    backgroundColor: '#ffffff',
    padding: 0
  },
  iconDropDown: {
    width: 20,
    height: 20,
    margin: '0px 2px 0px -12px',
    color: '#757575'
  }
};

const enhance = compose(withState('anchorEl', 'setAnchorEl', null));

const button = enhance(
  ({
    classes,
    disabled,
    isCheckedAll,
    onCheckAction,
    onUnCheckAction,
    anchorEl,
    setAnchorEl
  }) => {
    const open = Boolean(anchorEl);
    const handleClick = event => {
      if (disabled) return;
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
      <div>
        <Button
          id="check-all-button"
          aria-controls={open ? 'check-all-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          className={classes.button}
        >
          <Checkbox
            disabled={disabled}
            color="primary"
            checked={isCheckedAll}
          />
          <ArrowDropDownIcon className={classes.iconDropDown} />
          こどもごちめし参加設定
        </Button>
        <Menu
          id="check-all-menu"
          aria-labelledby="check-all-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 5,
            horizontal: -10
          }}
        >
          <MenuItem
            onClick={() => {
              onCheckAction();
              handleClose();
            }}
          >
            本ページ内すべて選択
          </MenuItem>
          <MenuItem
            onClick={() => {
              onUnCheckAction();
              handleClose();
            }}
          >
            本ページ内すべて選択解除
          </MenuItem>
        </Menu>
      </div>
    );
  }
);

export default withStyles(styles)(button);
